/**
 * Array of string replacements.
 * Auto-synced from `locales/en/content.json` → `story.rephrases`.
 * Used as a fallback when the locale content is unavailable.
 * @type {Array<Array<string>>}
 */
export default [
  ['8th Finals', 'Last 16'],
  ['16th Finals', 'Last 32'],
  ['Macedonia', 'N. Macedonia'],
  ['Cabo Verde', 'Cape Verde'],
  ['IR Iran', 'Iran'],
  ['Czechia', 'Czech Republic'],
  ['Turkiye', 'Turkey'],
  ['1st Group A', '1st place Group A'],
  ['2nd Group A', '2nd place Group A'],
  ['2nd Group B', '2nd place Group B'],
  ['1st Group C', '1st place Group C'],
  ['3rd Group D/E/F', '3rd place Group D/E/F'],
  ['1st Group D', '1st place Group D'],
  ['2nd Group F', '2nd place Group F'],
  ['1st Group E', '1st place Group E'],
  ['3rd Group A/B/C/D', '3rd place Group A/B/C/D'],
  ['3rd Group A/D/E/F', '3rd place Group A/D/E/F'],
  ['2nd Group C', '2nd place Group C'],
  ['2nd Group D', '2nd place Group D'],
  ['2nd ranked Group E', '2nd place Group E'],
  ['1st Group F,', '1st place Group F'],
  ['3rd Group A/B/C', '3rd place Group A/B/C'],
];
